import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import carLogo from "../assets/Group3.png";

// Icons
const MenuIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const XIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">

        {/* LOGO */}
        <NavLink to="/" className="navbar-logo" onClick={() => setIsOpen(false)}>
          <img src={carLogo} alt="Drivve" className="logo-icon" />
        </NavLink>

        {/* MENU ICON */}
        <div className="menu-icon" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <XIcon /> : <MenuIcon />}
        </div>

        {/* NAV LINKS */}
        <ul className={isOpen ? 'nav-menu active' : 'nav-menu'}>

          <li className="nav-item">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setIsOpen(false)}
            >
              Home
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setIsOpen(false)}
            >
              About Us
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/services"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setIsOpen(false)}
            >
              Services
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink
              to="/download"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setIsOpen(false)}
            >
              Download
            </NavLink>
          </li>

          {/* 🔔 FEEDBACK TAB */}
          <li className="nav-item">
            <NavLink
              to="/survey"
              className={({ isActive }) =>
                isActive ? "nav-link active" : "nav-link"
              }
              onClick={() => setIsOpen(false)}
            >
              Feedback
            </NavLink>
          </li>

        </ul>

      </div>
    </nav>
  );
};

export default Navbar;
